/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking a short guided-breathing or stretch break between work sprints.`)
};

const es_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomar una breve pausa de respiración guiada o de estiramiento entre sprints de trabajo.`)
};

const de_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine kurze geführte Atem- oder Dehnpause zwischen Arbeitssprints einlegen.`)
};

const nl_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een korte begeleide ademhalings- of rekpauze nemen tussen werksprints.`)
};

const fr_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prendre une courte pause de respiration guidée ou d’étirements entre les sprints de travail.`)
};

const it_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare una breve pausa di respirazione guidata o stretching tra gli sprint di lavoro.`)
};

const pt_br2_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma pausa curta de respiração guiada ou alongamento entre sprints de trabalho.`)
};

const pt_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma breve pausa de respiração guiada ou alongamento entre sprints de trabalho.`)
};

const ja_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業スプリントの合間に短いガイド付き呼吸法やストレッチ休憩を取る。`)
};

const zh_timer_u5m_use3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在工作冲刺之间进行简短的引导呼吸或拉伸休息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u5m_use3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u5m_use3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u5m_use3", locale)
	if (locale === "en") return en_timer_u5m_use3(inputs)
	if (locale === "es") return es_timer_u5m_use3(inputs)
	if (locale === "de") return de_timer_u5m_use3(inputs)
	if (locale === "nl") return nl_timer_u5m_use3(inputs)
	if (locale === "fr") return fr_timer_u5m_use3(inputs)
	if (locale === "it") return it_timer_u5m_use3(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u5m_use3(inputs)
	if (locale === "pt") return pt_timer_u5m_use3(inputs)
	if (locale === "ja") return ja_timer_u5m_use3(inputs)
	return zh_timer_u5m_use3(inputs)
};